export default {
  fallbackLng: 'en',
  defaultNS: 'common',
  fallbackNS: 'common',
  supportedLngs: [
    'cs',
    'da',
    'de',
    'en',
    'es',
    'fi',
    'fr',
    'it',
    'ja',
    'ko',
    'nb',
    'nl',
    'pl',
    'pt-BR',
    'pt-PT',
    'sv',
    'th',
    'tr',
    'zh-CN',
    'zh-TW',
  ],
  nonExplicitSupportedLngs: true,
}
